<ng-container *ngIf="!!config">
  <ckeditor [editor]="Editor" [config]="config" [formControl]="control" (ready)="onEditorReady($event)" [class.has-content]="control.value?.length > 0"></ckeditor>
  <rh-subscript-wrapper  *ngIf="!!control" [hasError]="!control.valid && control.touched" [disabled]="disabled">
    <ng-content select="rds-control-hint" ngProjectAs="rds-control-hint"></ng-content>
    <ng-content select="rds-control-error" ngProjectAs="rds-control-error"></ng-content>
  </rh-subscript-wrapper>
</ng-container>
